import { endOfMonth, isSameDay } from 'date-fns';

/**
 * Business rule: Show last-day-of-previous-month suggestion when
 *  - no date is selected, OR
 *  - the selected date is NOT the last day of its month.
 */
export function shouldShowLastDayOfPreviousMonthSuggestion(selectedDate?: Date): boolean {
  if (!selectedDate) return true;
  return !isSameDay(selectedDate, endOfMonth(selectedDate));
}

/**
 * Business rule: Show last-day-of-previous-year suggestion when
 *  - the selected date is NOT exactly the last day of the previous year.
 * (If no date is selected it should show.)
 */
export function shouldShowLastDayOfPreviousYearSuggestion(
  selectedDate: Date | undefined,
  referenceNow: Date = new Date(),
): boolean {
  if (!selectedDate) return true;
  const previousYear = referenceNow.getFullYear() - 1;
  const lastDayPrevYear = new Date(previousYear, 11, 31);
  return !(
    selectedDate.getFullYear() === lastDayPrevYear.getFullYear() &&
    selectedDate.getMonth() === lastDayPrevYear.getMonth() &&
    selectedDate.getDate() === lastDayPrevYear.getDate()
  );
}

/**
 * Business rule: Show last-day-of-current-month suggestion when
 *  - no date is selected, OR
 *  - the selected date is NOT the last day of its month.
 * Same check as shouldShowLastDayOfPreviousMonthSuggestion, kept as a separate
 * named function since it is semantically a different suggestion (forward vs. backward).
 */
export function shouldShowLastDayOfCurrentMonthSuggestion(selectedDate?: Date): boolean {
  if (!selectedDate) return true;
  return !isSameDay(selectedDate, endOfMonth(selectedDate));
}
